/**
 * Утилита для работы с Fetch-запросами.
 */

const AJAX = {
  /**
   * Выполняет GET-запрос по указанному URL.
   * @async
   * @param {string} url - URL для запроса.
   * @returns {Promise<Object|null>} Ответ в формате JSON или null в случае ошибки.
   */
  async get(url) {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Ошибка: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  /**
   * Выполняет POST-запрос по указанному URL с передачей данных.
   * @async
   * @param {string} url - URL для запроса.
   * @param {Object} data - Данные, отправляемые в теле запроса.
   * @returns {Promise<Object|null>} Ответ в формате JSON или null в случае ошибки.
   */
  async post(url, data) {
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      if (!response.ok) throw new Error(`Ошибка: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  /**
   * Выполняет PUT-запрос по указанному URL с передачей данных.
   * @async
   * @param {string} url - URL для запроса.
   * @param {Object} data - Данные, отправляемые в теле запроса.
   * @returns {Promise<Object|null>} Ответ в формате JSON или null в случае ошибки.
   */
  async put(url, data) {
    try {
      const response = await fetch(url, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      if (!response.ok) throw new Error(`Ошибка: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  /**
   * Выполняет DELETE-запрос по указанному URL.
   * @async
   * @param {string} url - URL для запроса.
   * @returns {Promise<Object|null>} Ответ в формате JSON или null в случае ошибки.
   */
  async delete(url) {
    try {
      const response = await fetch(url, { method: 'DELETE' });
      if (!response.ok) throw new Error(`Ошибка: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error(error);
      return null;
    }
  }
};

window.AJAX = AJAX;
